export default "__VITE_ASSET__bba78481__"